import { Autocomplete, Box, FormControl, InputLabel, Stack, TextField, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi3"
import theme from "css/theme/light"
import { apiEndpoints } from "generated/apiEndpoints"
import { FC, useEffect, useState } from "react"
import { StyledFormLabel } from "shared/styled/Global"
import { IFormSelectProps } from "./formvehiclepicker.interface"
import { isJson } from "components/TinyMCE/helpers";
import { useTranslation } from "react-i18next"

type SelectOptions = Array<{ label: string; value: string; internNumber: string }>

const FormVehiclePicker: FC<IFormSelectProps> = (props) => {
  const { id, labelKey, labelDefault, handleChange, value, optional, showInternNumber, helperText, error } = props
  const [vehiclesResult, vehiclesApi] = useApi() as [IApiResult, IApiFunc]
  const [vehicleOptions, setVehicleOptions] = useState<SelectOptions>()
  const { t } = useTranslation()

  useEffect(() => {
    vehiclesApi.get(apiEndpoints.form.getvehiclelist)
  }, [])

  useEffect(() => {
    if (vehiclesResult.status === 2) {
      const selectOptions: SelectOptions = vehiclesResult?.data
        ? vehiclesResult?.data?.map((vehicle: any) => ({
          label: vehicle.regNumber,
          value: vehicle.id,
          internNumber: vehicle.internnumber
        }))
        : []
      setVehicleOptions(selectOptions)
    }
  }, [vehiclesResult])

  return (
    <>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })} {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      <FormControl fullWidth>
        <Autocomplete
          loading
          loadingText={t("global.loading", "Loading") + "..."}
          sx={{ width: "100%", background: theme.palette.background.paper }}
          id={id?.toString()}
          options={vehicleOptions ? vehicleOptions : []}
          getOptionLabel={(option) =>
            showInternNumber && option.internNumber
              ? `${option.label} (${option.internNumber})`
              : option.label
          }
          onChange={(e, option) => handleChange && handleChange(option?.value)}
          includeInputInList
          renderOption={(props, option) => (
            <li {...props}>
              <Stack direction="row" spacing={2} justifyContent="space-between">
                <Box sx={{ fontWeight: 600, minWidth: "100px" }}>{option.label}</Box>
                <Box sx={{ opacity: 0.6 }}>{option.internNumber}</Box>
              </Stack>
            </li>
          )}
          value={vehicleOptions?.find((i) =>
            i.value?.toString() === value?.toString() ||
            (typeof value === 'string' && isJson(value) && i.value?.toString() === JSON.parse(value)?.Id?.toString())
          ) || null}
          renderInput={(params) => (
            <TextField
              {...params}
              name={id?.toString()}
              variant="outlined"
              error={error}
              helperText={helperText}
            />
          )}

        />
      </FormControl>
    </>
  )
}

export default FormVehiclePicker
